/* Little Lebanese — wizard funnel tracking for Meta (added 2026-10-08).
   Sends ONLY these browser events to pixel 1545889043860937 (no PageView, no ViewContent/AddToCart/Purchase,
   which keep coming from Shopify's Facebook & Instagram channel):
     LL_WizardOpen        custom    personaliser opened
     CustomizeProduct     standard  child's name + gender submitted (step 1 passed)  <- optimisation event
     LL_NameEntered       custom    same moment as CustomizeProduct (optimisation event for the Sales campaign)
     LL_WizardStep2..5    custom    step 2..5 reached (Arabic name, grandparents, dedication, photo)
     LL_ReachedPreorder   custom    step 6 (review + "Pre-order" button) reached
     LL_PreorderClick     custom    "Pre-order" button clicked
   Each fires at most once per page load. Purely observational: it watches the wizard's data-step attribute
   and never touches the wizard, the form or the page. The same events are also published to Shopify's
   Customer Events (Shopify.analytics.publish) as "ll_wizard". Remove the <script> line in snippets/ll-head.liquid to roll back. */
(function () {
  'use strict';
  var PIXEL = '1545889043860937', w = window, d = document;
  var dlg = d.querySelector('[data-ll-personalise]');
  if (!dlg) return;

  function allowed() {
    try { var cp = w.Shopify && w.Shopify.customerPrivacy; if (cp && typeof cp.marketingAllowed === 'function') return cp.marketingAllowed() !== false; } catch (e) {}
    return true;
  }
  var ready = false;
  function boot() {
    if (ready) return true;
    if (!allowed()) return false;
    if (w.fbq) { ready = true; return true; } /* Shopify's Facebook & Instagram app pixel already loaded + initialised it */
    {
      /* fallback: standard Meta base loader, without the usual fbq('track','PageView') */
      !function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); }(w, d, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    }
    w.fbq('set', 'autoConfig', false, PIXEL); /* no automatic button-click / microdata events */
    w.fbq('init', PIXEL);
    ready = true; return true;
  }
  /* LL 2026-10-12: label events with the product actually on the page (Book 1 or Book 2) */
  var meta = (w.ShopifyAnalytics && w.ShopifyAnalytics.meta && w.ShopifyAnalytics.meta.product) || {};
  var og = d.querySelector('meta[property="og:title"]');
  var pname = (og && og.getAttribute('content')) || d.title || '';
  var isB2 = /basbous/i.test(pname + ' ' + location.pathname);
  var isB3 = /olive[- ]harvest/i.test(pname + ' ' + location.pathname);
  var base = { content_name: isB3 ? 'Jeddo\'s Olive Harvest' : isB2 ? 'Basbous, Teta\'s Cat' : 'Maya Visits Teta in Lebanon', content_category: 'Personalised book', content_type: 'product', currency: 'USD', value: 45, book: isB3 ? 'book3' : isB2 ? 'book2' : 'book1' };
  if (meta.id) base.content_ids = [String(meta.id)];
  var sent = {};
  function send(name, standard, extra) {
    if (sent[name]) return; sent[name] = 1;
    var p = {}, k; for (k in base) p[k] = base[k]; if (extra) for (k in extra) p[k] = extra[k];
    try { if (w.Shopify && w.Shopify.analytics && typeof w.Shopify.analytics.publish === 'function') w.Shopify.analytics.publish('ll_wizard', { event: name, step: p.step || null }); } catch (e) {}
    if (!boot()) return;
    try { w.fbq(standard ? 'trackSingle' : 'trackSingleCustom', PIXEL, name, p); (w.__llTrack = w.__llTrack || []).push(name); } catch (e) {}
  }
  /* step count read from the wizard itself (Book 1 now has 7 steps, Book 2 has its own); last step = review */
  var stepsEl = dlg.querySelectorAll('.ll-ws'), N = stepsEl.length || 6;
  function nm(s) { var e = stepsEl[s - 1]; return e ? e.getAttribute('data-name') : ''; }
  function onStep() {
    if (!dlg.open) return;
    var s = +dlg.getAttribute('data-step') || 1;
    send('LL_WizardOpen', false, { step: 1 });
    if (s >= 2) send('CustomizeProduct', true, { step: 1, step_name: nm(1) });
    if (s >= 2) send('LL_NameEntered', false, { step: 1, step_name: nm(1) }); /* twin of CustomizeProduct: Sales-objective ad sets can't optimise for CustomizeProduct, but can for this custom event (custom conversion 1137252689242352) */
    if (s >= 2 && s < N) send('LL_WizardStep' + s, false, { step: s, step_name: nm(s) });
    if (s === N) send('LL_ReachedPreorder', false, { step: N, step_name: nm(N) });
  }
  new MutationObserver(onStep).observe(dlg, { attributes: true, attributeFilter: ['data-step', 'open'] });
  var buy = dlg.querySelector('[data-ll-buy-now]');
  if (buy) buy.addEventListener('click', function () { send('LL_PreorderClick', false, { step: N }); });
})();
